/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0307026f3a244cdc6efbdb1f615a4ca7>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Snippet".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for snippets in Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const SnippetIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.75 14.665a2.5 2.5 0 0 1-3.407-.902L8 10.046l-2.343 3.717a2.5 2.5 0 1 1-.09-2.67l1.546-2.454.886-1.407H8L11.866 1.1l1.268.8-4.247 6.74 1.546 2.453a2.5 2.5 0 1 1 3.317 3.572m-.75-1.3a1 1 0 1 1-1-1.731 1 1 0 0 1 1 1.732M4.366 13a1 1 0 1 1-1.732-1 1 1 0 0 1 1.732 1" clip-rule="evenodd"/><path fill="currentcolor" d="m7.113 5.825-.887 1.407-3.36-5.333 1.269-.8z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
SnippetIcon.displayName = 'SnippetIcon';
var _default = exports.default = SnippetIcon;